/* global PopStateEvent */
import { div, h1, h2, p, button, span, section, fnstate } from '@srfnstack/fntags'

const packages = fnstate([])
const plans = fnstate([])
const loading = fnstate(true)

const fetchBilling = async () => {
  try {
    const [pRes, sRes] = await Promise.all([
      fetch('/api/billing/credit-packages'),
      fetch('/api/billing/subscription-plans')
    ])
    if (pRes.ok) packages(await pRes.json())
    if (sRes.ok) plans(await sRes.json())
  } catch (err) {
    console.error('Failed to fetch billing info:', err)
  } finally {
    loading(false)
  }
}

const navigateToCheckout = (type, id) => {
  const url = `/billing/checkout?${type}=${id}`
  window.history.pushState({}, '', url)
  window.dispatchEvent(new PopStateEvent('popstate'))
}

export const BuyCredits = () => {
  fetchBilling()

  return div({ class: 'p-8 max-w-6xl mx-auto' },
    h1({ class: 'text-4xl font-bold mb-2 text-center' }, 'Fuel Your Automation'),
    p({ class: 'text-xl text-base-content/70 mb-12 text-center' }, 'Choose a plan or top up your credits to keep your print-on-demand engine running.'),

    loading.bindAs(l => l
      ? div({ class: 'flex justify-center p-12' }, span({ class: 'loading loading-spinner loading-lg text-primary' }))
      : div(
        section({ class: 'mb-16' },
          h2({ class: 'text-2xl font-bold mb-8 border-b border-base-300 pb-2' }, 'Subscription Plans'),
          plans.bindAs(plist => div({ class: 'grid grid-cols-1 md:grid-cols-3 gap-8' },
            plist.map(plan =>
              div({ class: 'card bg-base-200 shadow-xl border border-base-300 hover:border-primary transition-colors' },
                div({ class: 'card-body' },
                  h2({ class: 'card-title text-2xl' }, plan.name),
                  p({ class: 'text-base-content/70' }, plan.description),
                  div({ class: 'my-4' },
                    span({ class: 'text-4xl font-bold' }, `$${(plan.price_cents / 100).toFixed(0)}`),
                    span({ class: 'text-base-content/50 ml-1' }, '/ mo')
                  ),
                  div({ class: 'flex items-center gap-2 mb-6' },
                    span({ class: 'material-symbols-rounded text-success' }, 'check_circle'),
                    span(`${plan.monthly_credits} Credits / month`)
                  ),
                  div({ class: 'card-actions mt-auto' },
                    button({
                      class: 'btn btn-primary btn-block',
                      onclick: () => navigateToCheckout('planId', plan.id)
                    }, 'Subscribe Now')
                  )
                )
              )
            ))
          )
        ),

        section(
          h2({ class: 'text-2xl font-bold mb-8 border-b border-base-300 pb-2' }, 'One-Time Credit Packs'),
          packages.bindAs(pkgList => div({ class: 'grid grid-cols-1 md:grid-cols-3 gap-8' },
            pkgList.map(pkg =>
              div({ class: 'card bg-base-100 shadow-xl border border-base-300' },
                div({ class: 'card-body' },
                  h2({ class: 'card-title text-xl' }, pkg.name),
                  p({ class: 'text-base-content/70' }, pkg.description),
                  div({ class: 'my-4' },
                    span({ class: 'text-3xl font-bold' }, `$${(pkg.price_cents / 100).toFixed(0)}`)
                  ),
                  div({ class: 'flex items-center gap-2 mb-6' },
                    span({ class: 'material-symbols-rounded text-primary' }, 'token'),
                    span(`${pkg.credits} Instant Credits`)
                  ),
                  div({ class: 'card-actions mt-auto' },
                    button({
                      class: 'btn btn-outline btn-block',
                      onclick: () => navigateToCheckout('packageId', pkg.id)
                    }, 'Buy Credits')
                  )
                )
              )
            ))
          )
        )
      ))
  )
}
